// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1m44P","col":"styles_col__1c9EC"};